import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const usePortalBanners = () => {
  const { errorMessage } = useToast();

  return useQuery({
    queryKey: ['portalBanners'],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/banners`);
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
};
